import React from 'react';
var LoaderMi = function (_a) {
    var taille = _a.taille;
    var loaderClassName = "lds-dual-ring";
    var loaderContainerClassName = "loader-container dsmi-loader-container";
    if (taille) {
        loaderClassName += " lds-dual-ring--".concat(taille);
    }
    return (React.createElement("div", { className: loaderContainerClassName },
        React.createElement("div", { className: loaderClassName })));
};
export default LoaderMi;
